<template>
  <div>
    
    <template v-if="canEdit">
      <div class="flex justify-center items-center">
        <div class="flex items-center" v-for="n in 4" :key="n">
          <div class="border-red-500 border-2 rounded-full w-12 h-12 flex justify-center items-center text-lg font-bold shadow"
            :class="{ 'bg-red-500 text-white': n - 1 > activeStep, 'bg-white': n - 1 <= activeStep }">
            <div v-if="n > activeStep">{{ n }}</div>
            <font-awesome-icon :icon="['far', 'check']" class="text-green-500" v-else />
          </div>
          <div class="h-2px w-10 bg-gray-400" v-if="n < 4"></div>
        </div>
      </div>

      <div class="max-w-xl mx-auto mt-16">
        <register-details v-if="activeStep === 0" @submit="activeStep = 1"></register-details>
        <register-slots v-if="activeStep === 1" @prev="activeStep = 0" @submit="activeStep = 2"></register-slots>
        <register-contact v-if="activeStep === 2" @prev="activeStep = 1" @submit="activeStep = 3"></register-contact>
        <register-profile v-if="activeStep === 3" @prev="activeStep = 2" @submit="onFinish"></register-profile>
      </div>
    </template>

    <template v-else>
      <router-link :to="{ name: 'ap-home' }" class="btn btn-primary w-48 text-base">Til forsiden</router-link>
    </template>

  </div>
</template>

<script>

import RegisterDetails from './_Register_Details.vue'
import RegisterSlots from './_Register_Slots.vue'
import RegisterContact from './_Register_Contact.vue'
import RegisterProfile from './_Register_Profile.vue'
import api from '@/api'
import { get } from "lodash"
import { mapGetters } from "vuex"

export default {
  name: 'ap-register',
  components: {
    RegisterDetails,
    RegisterSlots,
    RegisterContact,
    RegisterProfile
  },
  data () {
    return {
      activeStep: 0,
      electionPeriod: null
    }
  },  
  computed: {
    ...mapGetters(["user"]), 
    isSupervising () {
      return this.user.isSupervising
    },
    currentStep () {
      return get(this.electionPeriod, "currentStep", -1)
    },
    canEdit () {      
      return this.isSupervising || (
             this.currentStep >= 0 &&
             this.currentStep <= 4)
    }
  },
  methods: {
    onFinish () {
      // this.$store.commit('api/getCurrentElectionPeriod')
      // this.$store.commit('api/getPharmacy')

      this.$router.push({ name: 'ap-home' })
    }
  },
  async created () {
    this.electionPeriod = await api.ap.getElectionPeriod()
  }
}
</script>
